export default "__VITE_ASSET__8bbf7c8b__"